import React from 'react';
import MenuItemWithDialog, { IMenuItemWithDialogProps } from '../MenuList/MenuItemWithDialog';
import LegendDialogContent, { ILegendDialogContentProps } from './LegendDialogContent';
import Checkin from '../../Icons/Checkin';

export interface ILegendMenuItemProps
  extends Omit<IMenuItemWithDialogProps, 'title' | 'Icon' | 'children'>,
    ILegendDialogContentProps {}

const LegendMenuItem: React.FC<ILegendMenuItemProps> = (props: ILegendMenuItemProps) => {
  return (
    <MenuItemWithDialog {...props} title="圖例說明" Icon={Checkin}>
      <LegendDialogContent activeLegends={props.activeLegends} />
    </MenuItemWithDialog>
  );
};
LegendMenuItem.displayName = 'LegendMenuItem';
export default LegendMenuItem;
